<script setup lang="ts">
  import { computed, provide, type HTMLAttributes } from 'vue'
  import { cn } from '../../lib/utils'
  import { type ButtonVariants, buttonSizeKey } from '../ui/button'

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class']
      /** Default size applied to contained buttons unless they set `size`. */
      buttonSize?: ButtonVariants['size']
    }>(),
    { buttonSize: 'lg' }
  )

  provide(
    buttonSizeKey,
    computed(() => props.buttonSize)
  )
</script>
<template>
  <div
    :class="cn('border-input flex justify-end gap-3 border-t p-5', props.class)"
  >
    <slot />
  </div>
</template>
